function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashboardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 4.045,
  height: 5.455,
  x: 3.15,
  y: 3.15,
  stroke: "currentColor",
  strokeWidth: 1.8,
  rx: 1,
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.045,
  height: 3.676,
  x: 10.805,
  y: 3.15,
  stroke: "currentColor",
  strokeWidth: 1.8,
  rx: 1,
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.045,
  height: 2.926,
  x: 3.15,
  y: 11.924,
  stroke: "currentColor",
  strokeWidth: 1.8,
  rx: 1,
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.045,
  height: 4.95,
  x: 10.805,
  y: 9.9,
  stroke: "currentColor",
  strokeWidth: 1.8,
  rx: 1,
  style: {
    fill: "none"
  }
}));
export { SvgDashboardIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxOCAxOCI+PHJlY3Qgd2lkdGg9IjQuMDQ1IiBoZWlnaHQ9IjUuNDU1IiB4PSIzLjE1IiB5PSIzLjE1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjgiIHJ4PSIxIiBzdHlsZT0iZmlsbDpub25lIi8+PHJlY3Qgd2lkdGg9IjQuMDQ1IiBoZWlnaHQ9IjMuNjc2IiB4PSIxMC44MDUiIHk9IjMuMTUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuOCIgcng9IjEiIHN0eWxlPSJmaWxsOm5vbmUiLz48cmVjdCB3aWR0aD0iNC4wNDUiIGhlaWdodD0iMi45MjYiIHg9IjMuMTUiIHk9IjExLjkyNCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS44IiByeD0iMSIgc3R5bGU9ImZpbGw6bm9uZSIvPjxyZWN0IHdpZHRoPSI0LjA0NSIgaGVpZ2h0PSI0Ljk1IiB4PSIxMC44MDUiIHk9IjkuOSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS44IiByeD0iMSIgc3R5bGU9ImZpbGw6bm9uZSIvPjwvc3ZnPg==";